module.exports = __webpack_public_path__ + "static/media/propic-10b.41a324a8.png";